if (!customElements.get('dy-gift-slider')) {
  customElements.define('dy-gift-slider', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.current = 0;
      this.querySelector('.controls').hidden = false;
      this.querySelectorAll('[data-dir]').forEach(button => button.addEventListener('click', () => this.show(this.current + Number(button.dataset.dir)), options));
      this.querySelectorAll('[data-index]').forEach(button => button.addEventListener('click', () => this.show(Number(button.dataset.index)), options));
      this.querySelector('.controls').addEventListener('keydown', event => {
        if (event.ctrlKey || event.metaKey || event.altKey) return;
        const next = {ArrowLeft:this.current-1,ArrowRight:this.current+1,Home:0,End:this.slides.length-1}[event.key];
        if(next !== undefined){event.preventDefault();this.show(next);}
      },options);
      const stage=this.querySelector('.stage');
      stage.addEventListener('touchstart',event=>{this.touch=event.touches.length===1?{x:event.touches[0].clientX,y:event.touches[0].clientY}:null;},{...options,passive:true});
      stage.addEventListener('touchend',event=>{
        if(!this.touch)return;
        const dx=event.changedTouches[0].clientX-this.touch.x,dy=event.changedTouches[0].clientY-this.touch.y;
        this.touch=null;
        if(Math.abs(dx)>50 && Math.abs(dx)>Math.abs(dy)*1.3)this.show(this.current+(dx<0?1:-1));
      },{...options,passive:true});
      stage.addEventListener('touchcancel',()=>{this.touch=null;},options);
      this.show(0);
    }
    show(index){
      this.current=(index+this.slides.length)%this.slides.length;
      this.slides.forEach((slide,i)=>{slide.classList.toggle('active',i===this.current);slide.inert=i!==this.current;});
      this.querySelectorAll('[data-index]').forEach((button,i)=>{button.classList.toggle('active',i===this.current);button.setAttribute('aria-pressed',String(i===this.current));});
      this.querySelector('.count').textContent=`${String(this.current+1).padStart(2,'0')} / ${String(this.slides.length).padStart(2,'0')}`;
    }
    disconnectedCallback(){this.controller?.abort();this.controller=null;}
  });
}
